/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import Select from 'react-select';
import makeAnimated from 'react-select/animated'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'
import { Select2Option, convertStringsSelect2Values } from '../../../helpers/utility'

type Props = {
  className?: string
  functionSubmit?: any
  options?: string[]
  selectedOption: string
}

const changeDropDownText = (e: React.MouseEvent<Element, MouseEvent>) => {
  const target = e.target as HTMLInputElement;
  target.parentElement!.parentElement!.parentElement!.children[0].children[0].textContent = target.textContent
}

const DropdownFilterSubject: FC<Props> = ({
  className = '',
  functionSubmit,
  options = [],
  selectedOption = LanguageHelp('All Subjects') }) => {

  const { mode } = useThemeMode()
  const animatedComponents = makeAnimated();

  return (
    <div className={className}>
      {/* <a href='#' className='btn btn-light btn-active-light-primary btn-sm' data-kt-menu-trigger='click' data-kt-menu-placement='bottom-end'>
        <div style={{ display: 'unset' }}>{selectedOption}</div>
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a> */}
      {/* begin::Menu */}
      {/* <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4 scroll-y mh-250px px-2' data-kt-menu='true'>
        {options.map((data, index) => (
        <div className='menu-item px-3' key={data + Math.random()}>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit(data, 'subject'); changeDropDownText(e); }} >
            {data}
          </a>
        </div>
        ))}
      </div> */}
      <Select
        className={mode === 'light' ? 'basic-single' : 'basic-single dark'}
        classNamePrefix="select"
        defaultValue={[new Select2Option(selectedOption)]}
        options={convertStringsSelect2Values(options)}
        isSearchable={true}
        noOptionsMessage={() => LanguageHelp('No matching records found')}
        placeholder={LanguageHelp('Select one/several subject(s)...')}
        onChange={(e: any) => { 
          functionSubmit(e == null ? "" : e.value, 'subject'); 
        }}
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: mode === 'light' ? '#f5f8fa' : '#2b2b40',
            borderWidth: "0px", borderRadius: "5px", minWidth: "170px", cursor: "pointer", fontSize: "12px", minHeight: '34px'
          })
          , menu: (base) => ({
            ...base,
            color: mode === 'light' ? '#7e8299 !important' : '#6d6d80 !important',
            backgroundColor: mode === 'light' ? '#f5f8fa' : '#1e1e2d',
            boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.3)',
            paddingLeft: '0px', paddingRight: '1px', cursor: "pointer"
          })
          , input: (base) => ({ ...base, color: mode === 'light' ? '#7e8299 !important' : '#6d6d80 !important', })
          , singleValue: (base) => ({ ...base, color: mode === 'light' ? '#7e8299 !important' : '#6d6d80 !important', })
          , indicatorSeparator: (base) => ({ ...base, display: 'none', })
          , dropdownIndicator: (base) => ({ ...base, color: mode === 'light' ? '#7e8299 !important' : '#6d6d80 !important', })
        }}
      // classNames={{
      //   menu: () =>  '',
      // }}
      />
      {/* end::Menu */}
    </div>
  )
}

export { DropdownFilterSubject }
